module.exports = __webpack_public_path__ + "img/group_elephant_logo.a92fc7b0.png";